export function normalizeProductReview(row) {
  return {
    id: row?.ProductReviewId ?? row?.productReviewId,
    productId: row?.ProductId ?? row?.productId,
    userId: row?.UserId ?? row?.userId,
    rating: Number(row?.Rating ?? row?.rating ?? 0),
    title: row?.ReviewTitle ?? row?.reviewTitle ?? '',
    text: row?.ReviewText ?? row?.reviewText ?? '',
    createdAt: row?.CreatedAt ?? row?.createdAt ?? null,
  };
}

export function computeRatingSummary(reviews = []) {
  const full = computeRatingDistribution(reviews);
  return {
    rating: full.rating,
    count: full.count,
    distribution: full.distribution,
  };
}

export function computeRatingDistribution(reviews = []) {
  const list = reviews.map(normalizeProductReview).filter((r) => r.rating > 0);
  const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

  if (!list.length) {
    return { rating: 0, count: 0, distribution };
  }

  list.forEach((item) => {
    const star = Math.min(5, Math.max(1, Math.round(item.rating)));
    distribution[star] += 1;
  });

  const count = list.length;
  const sum = list.reduce((total, item) => total + item.rating, 0);
  const percent = {};
  [5, 4, 3, 2, 1].forEach((star) => {
    percent[star] = Math.round((distribution[star] / count) * 100);
  });

  return {
    rating: Math.round((sum / count) * 10) / 10,
    count,
    distribution: percent,
  };
}

export function formatReviewDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
